import React from "react";
import "../css/Statistik.css"


function Statistik() {
  return (
    <section id="statistik">
      <div >
        <div class="justify-content-center rowstatistik">
            <div class="col-xs-6 col-sm-4 ">
              <p class="statistik-text">10+ Tahun  </p>
            Menjamin kenyamanan penumpang adalah amanah yang kami laksanakan dengan sebaik baiknya
            </div>
            <div class="col-xs-6 col-sm-4 row2">
              <p class="statistik-text"> 10 Provinsi</p>
            Jasa kami telah memberikan pelayanan, kemudahan dan menjangkau konsumen kami dengan mudah
            </div>
        </div>
      </div>
    </section>
  );
}

export default Statistik;